import { useState } from "react";
import { TrashIcon } from "@heroicons/react/24/solid";
import Modal from "../ui-components/Modal";
import {FormattedMessage} from "react-intl";

export const ConfirmDelete = ({
  onConfirm = () => {},
  onDismiss = () => {},
  showaskConfirm = false,
  confirmText = "OK",
  dismissText = "ANNULLA",
  showIcon=true,
}) => {
  const [askConfirm, setAskConfirm] = useState(showaskConfirm);
  return (
    <>
      {showIcon && (
        <div
          onClick={() => setAskConfirm(true)}
          className="ml-auto w-7 h-7 cursor-pointer text-red-600"
        >
          <TrashIcon />
        </div>
      )}
      {askConfirm && (
        <Modal
          type="warning"
          title={<FormattedMessage id="confirm_delete" />}
          description={<FormattedMessage id="confirm_delete_helper" />}
          onExit={() => {
            setAskConfirm(false);
            onDismiss();
          }}
          onDismiss={() => {
            setAskConfirm(false);
            onDismiss();
          }}
          onConfirm={() => {
            setAskConfirm(false);
            onConfirm();
          }}
          confirmText={confirmText}
          dismissText={dismissText}
        />
      )}
    </>
  );
};

export default ConfirmDelete;
